import React from 'react';

import DailyMatterItem, { DailyMatterItemBase } from './DailyMatterItem';

type ShiftCalenderItemUnassignedProps = DailyMatterItemBase;

/**
 * 未アサイン日次業務アイテム
 * @param props - プロパティ
 * @returns JSX要素
 */
const ShiftCalenderItemUnassigned: React.FunctionComponent<
  ShiftCalenderItemUnassignedProps
> = (props) => (
  <DailyMatterItem
    // dateString={props.dateString}
    // hidden={props.hidden}
    disabledButton={true}
    workContents={() => null}
    // isApplied={props.isApplied}
    onClickMatterExpense={props.onClickMatterExpense}
    {...props}
  />
);

export default ShiftCalenderItemUnassigned;
